import { render, staticRenderFns } from "./colonne_dechets.vue?vue&type=template&id=38bae185"
import script from "./colonne_dechets.js?vue&type=script&lang=js&external"
export * from "./colonne_dechets.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports